<template>
  <div class="home form-wrapper">
    <div class="d-flex align-items-md-center h-100 pt-5 pt-md-0">
      <b-container>
        <b-card>
          <h1 class="font-better-times display-4">Wave Waiver</h1>
          <p>You will not be permitted to participate in any booked activity at The Wave until a waiver has been completed. Please enter your booking details to view and sign the waiver.</p>

          <b-form class="w-100" novalidate @submit="checkForm">

            <b-form-group
              id="input-group-2"
              label="Booking number:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.BookingReference"
                type="text"
                required
                placeholder="Enter booking reference"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              label="Email address:"
              label-for="input-1"
              description="We'll never share your email with anyone else."
            >
              <b-form-input
                id="input-1"
                v-model="form.Email"
                type="email"
                required
                placeholder="Enter email"
              ></b-form-input>
            </b-form-group>

            <div v-if="formErrors.length">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-for="error in formErrors" :key="error">
                {{error}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>

            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error && error.length > 0">
              {{error}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <b-button type="submit" variant="primary" size="lg" block :disabled="form.BookingReference == undefined || form.Email == undefined">Continue</b-button>
          </b-form>

        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      form: {
        BookingReference: this.$route.query.accountId || undefined,
        Email: this.$route.query.email || undefined,
      },
      formErrors: [],
      error: this.$route.query.error === undefined ? undefined : decodeURIComponent(this.$route.query.error),
    }
  },
  methods: {
    checkForm(e){
      e.preventDefault();
      this.formErrors = [];

      //check required
      let missingInputs = 0;
      for(let formInput of e.target.elements) {
        const value = formInput.value.trim();

        if (formInput.nodeName === "INPUT" || formInput.nodeName === "TEXTAREA") {
          if(formInput.hasAttribute('required')){
            if(value){
              formInput.classList.remove("is-invalid");
              formInput.classList.add("is-valid");
            } else {
              formInput.classList.remove("is-valid");
              formInput.classList.add("is-invalid");
              missingInputs++;
            }
          }
        }

        if (formInput.nodeName === "SELECT"){
          if(value === "error"){
            formInput.classList.remove("is-valid");
            formInput.classList.add("is-invalid");
            missingInputs++;
          } else {
            formInput.classList.remove("is-invalid");
            formInput.classList.add("is-valid");
          }
        }
      }

      if(missingInputs > 0){
        this.formErrors.push("You are missing some required fields, please try again");
      } else {
        var re = /[0-9]{13}/;
        if(re.test(this.form.BookingReference)){
          this.onSubmit();
        } else {
          this.formErrors.push("Please provide a valid 13 digit booking number");
        }
      }

    },
    onSubmit(){
      if(this.form.BookingReference && this.form.Email){
        this.$router.push({ name: 'user-waiver-terms', query: { accountId: this.form.BookingReference, email: this.form.Email }});
      }
    }
  }
}
</script>
<style lang="scss">
  .form-wrapper {
    height: calc(100% - 103px);
  }
</style>
